// certificate-modal.js

export default (Alpine) => {
  Alpine.data("certificateModal", () => ({
    activeId: null,
    lastTrigger: null,
    scrollLockY: 0,
    variantId: null,
    variantIds: [],
    testingVariantIds: [],

    init() {
      const { variantId, variantIds, testingVariantIds } = this.$el.dataset;
      this.variantId = variantId;
      this.variantIds = (variantIds || '').split(',').filter(Boolean);
      this.testingVariantIds = (testingVariantIds || '').split(',').filter(Boolean);

      const thirdPartyBlock = this.$el;

      document.querySelectorAll('a[href="#certifications"]').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          event.preventDefault();
          const activeVariant = thirdPartyBlock.querySelector(`[data-certifications-variant="${this.variantId}"]`);
          const thirdPartyDetails = activeVariant?.querySelector('details');
          if (!thirdPartyDetails) return;

          thirdPartyDetails.open = true;
          window.scrollTo({ top: thirdPartyBlock.offsetTop - 100, behavior: 'smooth' });
          setTimeout(() => {
            thirdPartyDetails.querySelector('summary')?.focus();
          }, 100);
        });
      });
    },

    onVariantChanged(event) {
      const id = event.detail?.variant?.id;
      if (!id || !this.variantIds.includes(String(id))) return;

      this.closeModal();
      this.variantId = String(id);

      const hasTesting = this.testingVariantIds.includes(this.variantId);
      document.querySelectorAll('[data-third-party-testing-link]').forEach((link) => {
        link.classList.toggle('hidden', !hasTesting);
        link.classList.toggle('block', hasTesting);
      });
      document.querySelectorAll('[data-faq-accordion]').forEach((faq) => {
        faq.classList.toggle('border-b', !hasTesting);
      });
    },

    openModal(id, event) {
      this.lastTrigger = event?.currentTarget || null;
      this.activeId = id;
      this.lockScroll();

      this.$nextTick(() => {
        const modal = document.getElementById(id);
        const closeButton = modal?.querySelector("[data-modal-close]");
        (closeButton || modal)?.focus();
      });
    },

    closeModal() {
      if (this.activeId === null) return;
      this.activeId = null;
      this.unlockScroll();
      this.lastTrigger?.focus?.();
      this.lastTrigger = null;
    },

    lockScroll() {
      const body = document.body;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      this.scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
      body.classList.add("overflow-hidden");
      body.style.position = "fixed";
      body.style.top = `-${this.scrollLockY}px`;
      body.style.left = "0";
      body.style.width = "100%";
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    },

    unlockScroll() {
      const body = document.body;
      const html = document.documentElement;

      body.classList.remove("overflow-hidden");
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.width = "";
      body.style.paddingRight = "";

      // html carries scroll-behavior: smooth, which would animate the jump back.
      const scrollBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto";
      window.scrollTo(0, this.scrollLockY);
      html.style.scrollBehavior = scrollBehavior;
    },

    async downloadFile(url, filename) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = filename || "certificate.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      } catch (error) {
        window.open(url, "_blank", "noopener");
      }
    },

    trapFocus(event) {
      if (this.activeId === null) return;

      const modal = document.getElementById(this.activeId);
      if (!modal) return;

      const focusable = Array.from(
        modal.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input:not([type="hidden"]):not([disabled]), select:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  }));
};
